import React from "react";
import { oneOfType, oneOf, string, number, bool } from "prop-types";

import { connectToState } from "../redux/connect-api";

import { addToCompareCountSelector } from "../selectors";
import { Box } from "@mui/material";

const VIEWBOX_SIZE = "22px";

const CountIndicator = ({ count }) => {
  return (
    <Box
      sx={(theme) => ({
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        background: "white",
        border: `1px solid ${theme.palette.primary.main}`,
        color: "black",
        fontWeight: 600,
        fontSize: "14px",
        height: VIEWBOX_SIZE,
        width: VIEWBOX_SIZE,
      })}
    >
      {count}
    </Box>
  );
};

CountIndicator.propTypes = {
  count: number.isRequired,
  active: bool.isRequired,
};

const AddToCompareCountIndicator = ({ label, active, addToCompareCount = null }) => {
  const indicatorGraphic =
    addToCompareCount === null ? null : (
      <CountIndicator count={addToCompareCount} active={active} />
    );

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: "8px",
        position: "relative",
        zIndex: 10,
      }}
    >
      {label}
      {indicatorGraphic}
    </Box>
  );
};

AddToCompareCountIndicator.propTypes = {
  label: string.isRequired,
  active: bool.isRequired,
  addToCompareCount: oneOfType([oneOf([null]), number]),
};

const mapStateToProps = (state) => ({
  addToCompareCount: addToCompareCountSelector(state),
});

export default connectToState(mapStateToProps)(AddToCompareCountIndicator);
